import { React, useEffect, useState } from "react";
import { t } from "../../Helper";
import { useSelector } from "react-redux";

const WebPagesInfo = ({ onChange }) => {

  const [requiredWebPages, setRequiredWebPages] = useState(
    "Select web pages for your website"
  );

  const [homePage, setHomePage] = useState("Home");
  const [aboutUsPage, setAboutUsPage] = useState("About Us");
  const [contactUsPage, setContactUsPage] = useState("Contact Us");

  const [webPages, setWebPages] = useState([]);

  const { preferredLanguage, currentLanguage } = useSelector(
    (state) => state.settings
  );

  useEffect(() => {
    (async () => {
      try {
        const fetchedData = await t(
          requiredWebPages,
          currentLanguage,
          preferredLanguage
        );
        setRequiredWebPages(fetchedData);

        const fetchedData2 = await t(
          homePage,
          currentLanguage,
          preferredLanguage
        );
        setHomePage(fetchedData2);

        const fetchedData3 = await t(
          aboutUsPage,
          currentLanguage,
          preferredLanguage
        );
        setAboutUsPage(fetchedData3);

        const fetchedData4 = await t(
          contactUsPage,
          currentLanguage,
          preferredLanguage
        );
        setContactUsPage(fetchedData4);

      } catch (error) {
        console.error("Error fetching data:", error);
      }
    })();
  }, [preferredLanguage]);


  const handleToggle = (e) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      let selectedWebPages = webPages;
      selectedWebPages.push(e.target.value);
      setWebPages(selectedWebPages);
    } else {
      const index = webPages.indexOf(e.target.value);
      webPages.splice(index, 1);
      setWebPages(webPages);
    }
    onChange(webPages);
  };

  return (
    <>
      <div className="col-12">
        <label className="form-label section-title">{requiredWebPages}</label>
        <div className="row gx-2 gy-2">
          <div className="col-6 col-sm-4 col-md-2">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                onChange={handleToggle}
                name="pages"
                id="pageHome"
                value="Home"
              />
              <label className="form-check-label small" htmlFor="pageHome">
                {homePage}
              </label>
            </div>
          </div>
          <div className="col-6 col-sm-4 col-md-2">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                onChange={handleToggle}
                name="pages"
                id="pageAbout"
                value="About"
              />
              <label className="form-check-label small" htmlFor="pageAbout">
                {aboutUsPage}
              </label>
            </div>
          </div>
          <div className="col-6 col-sm-4 col-md-2">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                onChange={handleToggle}
                name="pages"
                value="Contact"
                id="pageContact"
              />
              <label className="form-check-label small" htmlFor="pageContact">
                {contactUsPage}
              </label>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WebPagesInfo;
